import { array, TestContext } from 'yup';

import { getSchema } from '@utils/schemaUtils';

import { mandatoryErrMessage } from '@constants/validationConstants';

export const recipientFields = {
	roles: array()
		.nullable()
		.test('roles', mandatoryErrMessage('Recipient')!, (value, context: TestContext) => {
			return !!((value && value.length) || (context.parent.users && context.parent.users.length));
		}),
	users: array()
		.nullable()
		.test('users', mandatoryErrMessage('Recipient')!, (value, context: TestContext) => {
			return !!((value && value.length) || (context.parent.roles && context.parent.roles.length));
		}),
};
export const recipientSchema = getSchema(recipientFields);
